"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableAds = getAvailableAds;
async function getAvailableAds(advertisingRepo, machineId) {
    return advertisingRepo.getAvailableAds(machineId);
}
